export default __webpack_public_path__ + "static/media/card-back.347ff2a3.png";